import keycloak from '@vindr/services/keycloak';
import dayjs from 'dayjs';

export const FILTER_TYPE = {
  INSTITUTION: 'institution_ids',
  ASSIGNED_AT: 'assigned_at',
  VISIT_ID: 'visit_id',
  PATIENT_NAME: 'patient_name',
  ORDER_GROUP: 'order_group',
  STATUS: 'status',
  PATIENT_ID: 'patient_id',
  STUDY_DESC: 'study_desc',
};

export const INITIAL_FILTER_ASSIGNED = {
  // assigned_at_from: extendDateOptions['This Month'][0].toISOString(),
  // assigned_at_to: extendDateOptions['This Month'][1].toISOString(),
  assigned_at_from: dayjs().startOf('days').toISOString(),
  assigned_at_to: dayjs().endOf('days').toISOString(),
  ...(keycloak.userInfo?.default_institution_id && {
    institution_ids: [keycloak.userInfo?.default_institution_id],
  }),
};
